/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppClosesRouteImport } from './routes/_app/closes'
import { Route as AppPdaCustomersRouteImport } from './routes/_app/pda-customers'
import { Route as AppPendingTransactionsRouteImport } from './routes/_app/pending-transactions'
import { Route as AppSendMessageRouteImport } from './routes/_app/send-message'
import { Route as AppTrashRouteImport } from './routes/_app/trash'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppProductFamilyRouteImport } from './routes/_app/$product/$family'
import { Route as AppDebtorsIndexRouteImport } from './routes/_app/debtors/index'
import { Route as AppSettingsCategoriesRouteImport } from './routes/_app/settings/categories'
import { Route as AppSettingsNationalitiesRouteImport } from './routes/_app/settings/nationalities'
import { Route as AppSettingsPricesRouteImport } from './routes/_app/settings/prices'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsYearsRouteImport } from './routes/_app/settings/years'
import { Route as AppDebtorsDebtorIdVehiclesRouteImport } from './routes/_app/debtors/$debtorId/vehicles'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups/index'
import { Route as AppSettingsGroupsGroupIdServicesRouteImport } from './routes/_app/settings/groups/$groupId/services'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppClosesRoute = AppClosesRouteImport.update({
  id: '/closes',
  path: '/closes',
  getParentRoute: () => AppRoute,
} as any)
const AppPdaCustomersRoute = AppPdaCustomersRouteImport.update({
  id: '/pda-customers',
  path: '/pda-customers',
  getParentRoute: () => AppRoute,
} as any)
const AppPendingTransactionsRoute = AppPendingTransactionsRouteImport.update({
  id: '/pending-transactions',
  path: '/pending-transactions',
  getParentRoute: () => AppRoute,
} as any)
const AppSendMessageRoute = AppSendMessageRouteImport.update({
  id: '/send-message',
  path: '/send-message',
  getParentRoute: () => AppRoute,
} as any)
const AppTrashRoute = AppTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProductFamilyRoute = AppProductFamilyRouteImport.update({
  id: '/$product/$family',
  path: '/$product/$family',
  getParentRoute: () => AppRoute,
} as any)
const AppDebtorsIndexRoute = AppDebtorsIndexRouteImport.update({
  id: '/debtors/',
  path: '/debtors/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCategoriesRoute = AppSettingsCategoriesRouteImport.update({
  id: '/settings/categories',
  path: '/settings/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsNationalitiesRoute =
  AppSettingsNationalitiesRouteImport.update({
    id: '/settings/nationalities',
    path: '/settings/nationalities',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsPricesRoute = AppSettingsPricesRouteImport.update({
  id: '/settings/prices',
  path: '/settings/prices',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsYearsRoute = AppSettingsYearsRouteImport.update({
  id: '/settings/years',
  path: '/settings/years',
  getParentRoute: () => AppRoute,
} as any)
const AppDebtorsDebtorIdVehiclesRoute =
  AppDebtorsDebtorIdVehiclesRouteImport.update({
    id: '/debtors/$debtorId/vehicles',
    path: '/debtors/$debtorId/vehicles',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/settings/groups/',
  path: '/settings/groups/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsGroupIdServicesRoute =
  AppSettingsGroupsGroupIdServicesRouteImport.update({
    id: '/settings/groups/$groupId/services',
    path: '/settings/groups/$groupId/services',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/closes': typeof AppClosesRoute
  '/pda-customers': typeof AppPdaCustomersRoute
  '/pending-transactions': typeof AppPendingTransactionsRoute
  '/send-message': typeof AppSendMessageRoute
  '/trash': typeof AppTrashRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/$product/$family': typeof AppProductFamilyRoute
  '/settings/categories': typeof AppSettingsCategoriesRoute
  '/settings/nationalities': typeof AppSettingsNationalitiesRoute
  '/settings/prices': typeof AppSettingsPricesRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/years': typeof AppSettingsYearsRoute
  '/debtors/': typeof AppDebtorsIndexRoute
  '/debtors/$debtorId/vehicles': typeof AppDebtorsDebtorIdVehiclesRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$groupId/services': typeof AppSettingsGroupsGroupIdServicesRoute
}
export interface FileRoutesByTo {
  '/closes': typeof AppClosesRoute
  '/pda-customers': typeof AppPdaCustomersRoute
  '/pending-transactions': typeof AppPendingTransactionsRoute
  '/send-message': typeof AppSendMessageRoute
  '/trash': typeof AppTrashRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/$product/$family': typeof AppProductFamilyRoute
  '/settings/categories': typeof AppSettingsCategoriesRoute
  '/settings/nationalities': typeof AppSettingsNationalitiesRoute
  '/settings/prices': typeof AppSettingsPricesRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/years': typeof AppSettingsYearsRoute
  '/debtors': typeof AppDebtorsIndexRoute
  '/debtors/$debtorId/vehicles': typeof AppDebtorsDebtorIdVehiclesRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$groupId/services': typeof AppSettingsGroupsGroupIdServicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/closes': typeof AppClosesRoute
  '/_app/pda-customers': typeof AppPdaCustomersRoute
  '/_app/pending-transactions': typeof AppPendingTransactionsRoute
  '/_app/send-message': typeof AppSendMessageRoute
  '/_app/trash': typeof AppTrashRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$product/$family': typeof AppProductFamilyRoute
  '/_app/settings/categories': typeof AppSettingsCategoriesRoute
  '/_app/settings/nationalities': typeof AppSettingsNationalitiesRoute
  '/_app/settings/prices': typeof AppSettingsPricesRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/settings/years': typeof AppSettingsYearsRoute
  '/_app/debtors/': typeof AppDebtorsIndexRoute
  '/_app/debtors/$debtorId/vehicles': typeof AppDebtorsDebtorIdVehiclesRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/_app/settings/groups/$groupId/services': typeof AppSettingsGroupsGroupIdServicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/closes'
    | '/pda-customers'
    | '/pending-transactions'
    | '/send-message'
    | '/trash'
    | '/auth/launch'
    | '/$product/$family'
    | '/settings/categories'
    | '/settings/nationalities'
    | '/settings/prices'
    | '/settings/users'
    | '/settings/years'
    | '/debtors/'
    | '/debtors/$debtorId/vehicles'
    | '/settings/groups/'
    | '/settings/groups/$groupId/services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/closes'
    | '/pda-customers'
    | '/pending-transactions'
    | '/send-message'
    | '/trash'
    | '/auth/launch'
    | '/'
    | '/$product/$family'
    | '/settings/categories'
    | '/settings/nationalities'
    | '/settings/prices'
    | '/settings/users'
    | '/settings/years'
    | '/debtors'
    | '/debtors/$debtorId/vehicles'
    | '/settings/groups'
    | '/settings/groups/$groupId/services'
  id:
    | '__root__'
    | '/_app'
    | '/_app/closes'
    | '/_app/pda-customers'
    | '/_app/pending-transactions'
    | '/_app/send-message'
    | '/_app/trash'
    | '/auth/launch'
    | '/_app/'
    | '/_app/$product/$family'
    | '/_app/settings/categories'
    | '/_app/settings/nationalities'
    | '/_app/settings/prices'
    | '/_app/settings/users'
    | '/_app/settings/years'
    | '/_app/debtors/'
    | '/_app/debtors/$debtorId/vehicles'
    | '/_app/settings/groups/'
    | '/_app/settings/groups/$groupId/services'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/closes': {
      id: '/_app/closes'
      path: '/closes'
      fullPath: '/closes'
      preLoaderRoute: typeof AppClosesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pda-customers': {
      id: '/_app/pda-customers'
      path: '/pda-customers'
      fullPath: '/pda-customers'
      preLoaderRoute: typeof AppPdaCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pending-transactions': {
      id: '/_app/pending-transactions'
      path: '/pending-transactions'
      fullPath: '/pending-transactions'
      preLoaderRoute: typeof AppPendingTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/send-message': {
      id: '/_app/send-message'
      path: '/send-message'
      fullPath: '/send-message'
      preLoaderRoute: typeof AppSendMessageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trash': {
      id: '/_app/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AppTrashRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$product/$family': {
      id: '/_app/$product/$family'
      path: '/$product/$family'
      fullPath: '/$product/$family'
      preLoaderRoute: typeof AppProductFamilyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debtors/': {
      id: '/_app/debtors/'
      path: '/debtors'
      fullPath: '/debtors/'
      preLoaderRoute: typeof AppDebtorsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/categories': {
      id: '/_app/settings/categories'
      path: '/settings/categories'
      fullPath: '/settings/categories'
      preLoaderRoute: typeof AppSettingsCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/nationalities': {
      id: '/_app/settings/nationalities'
      path: '/settings/nationalities'
      fullPath: '/settings/nationalities'
      preLoaderRoute: typeof AppSettingsNationalitiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/prices': {
      id: '/_app/settings/prices'
      path: '/settings/prices'
      fullPath: '/settings/prices'
      preLoaderRoute: typeof AppSettingsPricesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/years': {
      id: '/_app/settings/years'
      path: '/settings/years'
      fullPath: '/settings/years'
      preLoaderRoute: typeof AppSettingsYearsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debtors/$debtorId/vehicles': {
      id: '/_app/debtors/$debtorId/vehicles'
      path: '/debtors/$debtorId/vehicles'
      fullPath: '/debtors/$debtorId/vehicles'
      preLoaderRoute: typeof AppDebtorsDebtorIdVehiclesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/settings/groups'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/$groupId/services': {
      id: '/_app/settings/groups/$groupId/services'
      path: '/settings/groups/$groupId/services'
      fullPath: '/settings/groups/$groupId/services'
      preLoaderRoute: typeof AppSettingsGroupsGroupIdServicesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppClosesRoute: typeof AppClosesRoute
  AppPdaCustomersRoute: typeof AppPdaCustomersRoute
  AppPendingTransactionsRoute: typeof AppPendingTransactionsRoute
  AppSendMessageRoute: typeof AppSendMessageRoute
  AppTrashRoute: typeof AppTrashRoute
  AppIndexRoute: typeof AppIndexRoute
  AppProductFamilyRoute: typeof AppProductFamilyRoute
  AppSettingsCategoriesRoute: typeof AppSettingsCategoriesRoute
  AppSettingsNationalitiesRoute: typeof AppSettingsNationalitiesRoute
  AppSettingsPricesRoute: typeof AppSettingsPricesRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppSettingsYearsRoute: typeof AppSettingsYearsRoute
  AppDebtorsIndexRoute: typeof AppDebtorsIndexRoute
  AppDebtorsDebtorIdVehiclesRoute: typeof AppDebtorsDebtorIdVehiclesRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
  AppSettingsGroupsGroupIdServicesRoute: typeof AppSettingsGroupsGroupIdServicesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppClosesRoute: AppClosesRoute,
  AppPdaCustomersRoute: AppPdaCustomersRoute,
  AppPendingTransactionsRoute: AppPendingTransactionsRoute,
  AppSendMessageRoute: AppSendMessageRoute,
  AppTrashRoute: AppTrashRoute,
  AppIndexRoute: AppIndexRoute,
  AppProductFamilyRoute: AppProductFamilyRoute,
  AppSettingsCategoriesRoute: AppSettingsCategoriesRoute,
  AppSettingsNationalitiesRoute: AppSettingsNationalitiesRoute,
  AppSettingsPricesRoute: AppSettingsPricesRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppSettingsYearsRoute: AppSettingsYearsRoute,
  AppDebtorsIndexRoute: AppDebtorsIndexRoute,
  AppDebtorsDebtorIdVehiclesRoute: AppDebtorsDebtorIdVehiclesRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
  AppSettingsGroupsGroupIdServicesRoute: AppSettingsGroupsGroupIdServicesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
